export const getDaysInMonth = (year: number, month: number): number =>
	new Date(year, month + 1, 0).getDate()

export const getFirstDayOfWeek = (year: number, month: number): number => {
	const day = new Date(year, month, 1).getDay()
	return day === 0 ? 6 : day - 1 // Convert Sun=0 → Mon=0..Sun=6
}

export const isSameDay = (a: Date, b: Date): boolean =>
	a.getFullYear() === b.getFullYear() &&
	a.getMonth() === b.getMonth() &&
	a.getDate() === b.getDate()

export const isSameMonth = (a: Date, b: Date): boolean =>
	a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth()

export const isDateInRange = (date: Date, start: Date, end: Date): boolean => {
	const t = date.getTime()
	return t > start.getTime() && t < end.getTime()
}

export const getWeekdayNames = (language?: string): string[] => {
	const fmt = new Intl.DateTimeFormat(language || "en-US", {
		weekday: "short",
	})
	return Array.from({ length: 7 }, (_, i) =>
		fmt.format(new Date(2025, 0, 6 + i)),
	)
}

export const getMonthNames = (language?: string): string[] => {
	const fmt = new Intl.DateTimeFormat(language || "en-US", { month: "long" })
	return Array.from({ length: 12 }, (_, i) =>
		fmt.format(new Date(2025, i, 1)),
	)
}

export const formatDisplayDate = (date: Date, locale = "en-US"): string => {
	const weekday = date.toLocaleDateString(locale, { weekday: "short" })
	const day = String(date.getDate()).padStart(2, "0")
	const month = String(date.getMonth() + 1).padStart(2, "0")
	return `${weekday}, ${day}.${month}.${date.getFullYear()}`
}

export const formatDisplayMonth = (date: Date, language?: string): string => {
	return date.toLocaleDateString(language || "en-US", {
		month: "long",
		year: "numeric",
	})
}
